import { createApp } from '@app/adapters/create-app'

const mountOnDom = (onDomLoad) => (componentDefinitionMap) => {
  const componentKeys = [...componentDefinitionMap.keys()]
  componentKeys.forEach((key) => {
    onDomLoad(function ($dom) {
      $dom
        .get(0)
        .querySelectorAll(key)
        .forEach((el) => {
          const props = Object.keys(el.dataset).reduce((acc, key) => {
            try {
              const val = JSON.parse(el.dataset[key])
              acc[key] = val
            } catch (e) {
              acc[key] = el.dataset[key]
            }

            return acc
          }, {})

          const app = createApp(
            componentDefinitionMap.get(key).component,
            {
              ...props,
            },
            componentDefinitionMap.get(key).meta || {}
          )

          const vuexStore =
            typeof componentDefinitionMap.get(key)?.createStore === 'function'
              ? componentDefinitionMap.get(key).createStore(el.dataset)
              : null

          if (vuexStore) {
            app.use(vuexStore)
          }

          app.mount(el)
        })
    })
  })
  return componentDefinitionMap
}

/**
 * Readies a global mounter
 * @param {Function} onDomLoad - an abstraction providing access to the document when it's ready
 * @returns { GlobalMounter } - The global mounter instance that accepts the list of components
 */
export const globalMounter = (onDomLoad) => {
  return mountOnDom(onDomLoad)
}

/**
 * Registers the given list of components globally and mounts them on the dom if encountered
 * @callback GlobalMounter - globalMounterCallback
 * @param {ComponentMap} - The components to register globally and mount on the dom, provided as a Map
 */

/**
 * A map containing keys / vue components
 * @typedef {Map<String, Function>} ComponentMap
 */
